import { LogManager } from '../../../common/port/log/log.manager.port';
import { toPaginatedResult } from '../../../../src/common/utils/paginate.util';
import { GetSelfTopAppCategoryAppsQuery } from '../../queries/app-category-metrics/get-self-top-app-category-apps.query';
import { GetSelfTopAppCategoryAppsRequestDto } from '../../dtos/app-category-metrics/get-self-top-app-category-apps.request.dto';
import { GetSelfTopAppCategoryAppsResponseDto } from '../../dtos/app-category-metrics/get-self-top-app-category-apps.response.dto';
import { SelfTopAppCategoryAppsAggregateRootMapper } from '../../../infrastructure/mappers/app-category-metrics/self-top-app-category-apps.aggregate-root.mapper';

export class GetSelfTopAppCategoryAppsController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetSelfTopAppCategoryAppsQuery,
    protected readonly mapper: SelfTopAppCategoryAppsAggregateRootMapper
  ) {}

  async get(
    props: GetSelfTopAppCategoryAppsRequestDto
  ): Promise<GetSelfTopAppCategoryAppsResponseDto> {
    try {
      const result = await this.query.execute(props);
      return toPaginatedResult(
        result.map((r) => this.mapper.toResponse(r)),
        props.params.limit,
        props.params.offset
      );
    } catch (error) {
      throw new Error(
        `GetSelfTopAppCategoryAppsController.get encountered an error ${error}`
      );
    }
  }
}
